export interface Display { 
  show: boolean;
}

export const SHOW = false;